@if (spinnerService.loading$ | async) {
    <div class="spinner-overlay">
        <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
}